export default "__VITE_ASSET__CjxTmOqR__"